import AtLoadingDisplay from "../components/LoadingDisplay.vue"
import AtLoadingFailed from "../components/LoadingFailed.vue"

export const componentLoad: (importer: Function) => any = (importer: Function) => {
    return () => ({
        component: importer(),
        loading: AtLoadingDisplay,
        error: AtLoadingFailed,
        timeout: 10000
    });
};

